export default "__VITE_ASSET__da83d7f7__"